<template>
  <div>
    <div >
      <div >
        <div class="logo-container">
          <img
            v-if="customLogoUrl"
            v-bind:src="customLogoUrl"
            alt="Company logo"
            class="logo"
          />
          <img
            v-else
            src="../assets/en_logo.png"
            alt="Employee Navigator"
            class="logo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginHeader',
  props: ["customLogoUrl"]
};
</script>
